import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster, toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next'; 
import './i18n';
import io from 'socket.io-client';
import axios from 'axios';
import { API_BASE } from './apiConfig'; 

// Components
import Home from './Home';
import About from './About';
import Contact from './Contact';
import ServiceDetail from './ServiceDetail';
import SubServicePage from './SubServicePage';
import Footer from './Footer';
import Register from './Register';
import UserLogin from './UserLogin';
import ChatBot from './ChatBot';
import Notifications from './Notifications';
import Profile from './Profile';
import Projects from './Portfolio';
import Partners from './Partners';
import Terms from './Terms';
import MyOrders from './MyOrders';
import Admin from './Admin';
import Favorites from './Favorites';
import Navbar from './Navbar';
import CallModal from './CallModal';
import MobileBottomNav from './MobileBottomNav';
// App.js-ի վերևի մասում (import-ների բաժնում) ավելացրու սա.
import CalculatorsHub from './CalculatorsHub';
import OrderActionModal from './OrderActionModal';
import BlogList from './blog/BlogList';
import BlogDetail from './blog/BlogDetail';
import './App.css';
import { mobileNavStyle, navItemStyle, callButtonStyle } from './styles';
import SEOManager from './SEOManager'; // Համոզվիր, որ ֆայլի անունը և ճանապարհը ճիշտ են

// SOCKET INITIALIZATION
const socket = io(API_BASE, {
    transports: ['websocket'],
    auth: {
        token: localStorage.getItem('token')
    },
    reconnection: true,
    reconnectionAttempts: 5
});

function AppContent() {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const audio = useMemo(() => new Audio('/notification.mp3'), []);

    // --- States ---
    const [user, setUser] = useState(() => {
        const saved = localStorage.getItem('liber_user');
        try { return saved ? JSON.parse(saved) : null; } catch { return null; }
    });
    
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showCallModal, setShowCallModal] = useState(false);
    const [isNotifOpen, setIsNotifOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const [lastOrders, setLastOrders] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [settings, setSettings] = useState({ phone: '', email: '', address: '' });
    const [categories, setCategories] = useState([]);
    const [subservices, setSubservices] = useState([]);
    const [partners, setPartners] = useState([]);
    const [openCat, setOpenCat] = useState(null);
// Փոխված տարբերակը useMemo-ով
    const STATUS_STYLES = useMemo(() => ({
        new: { 
            color: '#FF9933', 
            label: t('status_new'), 
            bg: 'rgba(255, 153, 51, 0.1)', 
            icon: '✨' 
        },
        processing: { 
            color: '#4318FF', 
            label: t('status_processing'), 
            bg: 'rgba(67, 24, 255, 0.1)', 
            icon: '⚙️' 
        },
        pending_admin: { 
            color: '#ecc94b', 
            label: t('status_pending_admin'), 
            bg: 'rgba(236, 201, 75, 0.1)', 
            icon: '⏳' 
        },
        confirmed: { 
            color: '#007BFF', 
            label: t('status_confirmed'), 
            bg: 'rgba(0, 123, 255, 0.1)', 
            icon: '✅' 
        },
        mismatch: { 
            color: '#E74C3C', 
            label: t('status_mismatch'), 
            bg: 'rgba(231, 76, 60, 0.1)', 
            icon: '🚨' 
        },
        in_progress: { 
            color: '#9b59b6', 
            label: t('status_in_progress'), 
            bg: 'rgba(155, 89, 182, 0.1)', 
            icon: '🚀' 
        },
        finished: { 
            color: '#01B574', 
            label: t('status_finished'), 
            bg: 'rgba(1, 181, 116, 0.1)', 
            icon: '🏆' 
        },
        cancelled: { 
            color: '#718096', 
            label: t('status_cancelled'), 
            bg: 'rgba(113, 128, 150, 0.1)', 
            icon: '❌' 
        }
    }), [t]); // Սա նշանակում է, որ հենց t-ն փոխվի (լեզուն), label-ները կթարմանան

    // --- Միասնական STATE Մոդալի համար (թե՛ վերահաշվարկ, թե՛ ավարտ) ---
    const [orderActionModal, setOrderActionModal] = useState({ isOpen: false, data: null });

    const isAdminPath = location.pathname.startsWith('/admin') || location.pathname === '/login';
    
  const statusTranslations = useMemo(() => ({
        'new': t('notif_new'), 
        'pending': t('notif_pending'), 
        'accepted': t('notif_accepted'),
        'confirmed': t('notif_confirmed'), 
        'cancelled': t('notif_cancelled'), 
        'completed': t('notif_completed'),
        'pending_approval': t('notif_pending_approval'), 
        'pending_finish': t('notif_pending_finish')
    }), [t]);

    const closeAll = useCallback(() => { 
        setIsMenuOpen(false); 
        setShowCallModal(false); 
        setIsNotifOpen(false); 
    }, []);
useEffect(() => {
    const trackVisit = async () => {
        // 1. Որոշում ենք սարքի տեսակը (Mobile թե Desktop)
        const ua = navigator.userAgent;
        let deviceType = "Desktop";
        if (/tablet|ipad|playbook|silk/i.test(ua)) {
            deviceType = "Tablet";
        } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Opera Mini/i.test(ua)) {
            deviceType = "Mobile";
        }

        // 2. Որոշում ենք՝ արդյոք հավելվածից է (WebView)
        // Սա աշխատում է, եթե հավելվածի ներսում ստուգում եք standalone ռեժիմը
        const isApp = window.matchMedia('(display-mode: standalone)').matches || 
                      window.navigator.standalone || 
                      ua.includes('YourAppName'); // Փոխեք YourAppName-ը ձեր հավելվածի անունով

        const visitData = {
            referrer: document.referrer || 'Direct',
            pathName: window.location.pathname,
            screenSize: `${window.innerWidth}x${window.innerHeight}`,
            device: deviceType, // Ավելացրինք սարքը
            platform: isApp ? "App" : "Browser", // Ավելացրինք պլատֆորմը
            userAgent: ua // Լրիվ տեքստը՝ ամեն դեպքում բազայում ունենալու համար
        };

        console.log("📤 Ուղարկվում է track-visit...", visitData);

        try {
            const response = await fetch(`${API_BASE}/api/admin/track-visit`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(visitData)
            });

            if (response.ok) {
                console.log("✅ Այցը գրանցվեց:", deviceType, isApp ? "(App)" : "(Browser)");
            }
        } catch (error) {
            console.error("❌ Կապի սխալ:", error);
        }
    };

    trackVisit();
}, [window.location.pathname]); // Սա թույլ կտա գրանցել ամեն անգամ, երբ օգտատերը փոխում է էջը // Սա կաշխատի միայն կայքը թարմացնելիս (session start) // Աշխատում է միայն մեկ անգամ՝ էջը բացելիս
    // --- ՄԻԱՍՆԱԿԱՆ ԳՈՐԾՈՂՈՒԹՅՈՒՆՆԵՐԻ ՀԱՆԴԼԵՐ (ԱՅՈ / ՈՉ / ՎՃԱՐԵԼ) ---
const handleOrderAction = async (type, payload) => {
    const token = localStorage.getItem('token');
    
    try {
        if (type === 'approve_revision' || type === 'reject_revision') {
            const action = type === 'approve_revision' ? 'approve' : 'reject';

            const res = await axios.post(`${API_BASE}/api/orders/revision-response`, 
                { 
                    orderId: payload.newOrderId || payload.id, 
                    parentId: payload.oldOrderId, 
                    action 
                }, 
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (action === 'approve' && res.data.success) {
                try {
                    await axios.post(`${API_BASE}/api/orders/create`, {
                        serviceId: payload.serviceId,
                        totalPrice: payload.newPrice,
                        address: payload.address,
                        userId: user.id,
                        isFromRevision: true
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    // ✨ Թարգմանված
                    toast.success(t('order_confirmed_success'));
                } catch (createErr) {
                    console.error("Order creation error:", createErr);
                    // ✨ Թարգմանված
                    toast.error(t('order_creation_error'));
                }
            } else if (action === 'reject') {
                // ✨ Թարգմանված
                toast.success(t('rejected_msg'));
            }

        } else if (type === 'pay_finish') {
            const res = await axios.post(`${API_BASE}/api/orders/confirm-finish`, 
                { 
                    orderId: payload.orderId || payload.id, 
                    rating: payload.rating,
                    paymentMethod: payload.paymentMethod 
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.data.success) {
                // ✨ Թարգմանված
                toast.success(t('order_finished_thanks'));
            }
        }

        setOrderActionModal({ isOpen: false, data: null });
        setTimeout(() => window.location.reload(), 1500);

    } catch (err) {
        // ✨ Թարգմանված
        toast.error(t('action_error'));
        console.error("Action Error:", err.response?.data || err.message);
    }
};
const markAsRead = useCallback(async () => {
    if (!user?.id) return;

    // 1. UI-ում միանգամից զրոյացնում ենք
    setUnreadCount(0);
    setLastOrders(prev => prev.map(n => ({ ...n, is_read: 1 })));

    try {
        let token = localStorage.getItem('token');
        if (token && token.startsWith('"')) token = JSON.parse(token);

        // ✅ Փոխում ենք PUT-ը POST-ի և հանում ենք ID-ն հասցեից
        // Քանի որ քո Backend-ը userId-ն ավտոմատ վերցնում է Token-ից
        await axios.post(`${API_BASE}/api/notifications/mark-as-read`, {}, {
            headers: { 
                'Authorization': `Bearer ${token}`
            }
        });
        
        console.log("Notifications marked as read");
    } catch (err) {
       console.error("API Request Error:", err.response?.data || err.message);
    }
}, [user?.id]);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

   useEffect(() => {
    const fetchGlobalData = async () => {
        try {
            const token = localStorage.getItem('token');
            const headers = { 
               
                'Authorization': token ? `Bearer ${token}` : '' // Ավելացրու տոկենը բոլոր հարցումներին
            };

            // 1. Սրանք ընդհանուր տվյալներն են (առանց լոգինի էլ պետք են)
            const [sRes, cRes, subRes, pRes] = await Promise.all([
                fetch(`${API_BASE}/api/settings`, { headers }),
                fetch(`${API_BASE}/api/categories`, { headers }),
                fetch(`${API_BASE}/api/subservices`, { headers }),
                fetch(`${API_BASE}/api/partners`, { headers })
            ]);

            if (sRes.ok) setSettings(await sRes.json());
            if (cRes.ok) setCategories(await cRes.json());
            if (subRes.ok) setSubservices(await subRes.json());
            if (pRes.ok) setPartners(await pRes.json());

            // 2. Միայն եթե յուզերը կա ու տոկենը կա
            if (user?.id && token) {
                axios.get(`${API_BASE}/api/notifications/${user.id}`, {
                    headers: { 
                        'Authorization': `Bearer ${token}`, 
                         
                    }
                }).then(res => {
                    setLastOrders(res.data.slice(0, 10));
                    const unread = res.data.filter(n => Number(n.is_read) === 0).length;
                    setUnreadCount(unread);
                }).catch(err => {
                    if(err.response?.status === 401) {
                        console.warn("Session expired or token missing");
                    }
                });
            }
        } catch (e) { 
            console.error("Global fetch error", e); 
        }
    };

    fetchGlobalData();
}, [user?.id]); // 🔥 Սա շատ կարևոր է, որ user-ը փոխվելիս նորից աշխատի

    // Socket & Notifications Listener
  // 1. Նախ սահմանում ենք useCallback-ը՝ useEffect-ից ԴՈՒՐՍ
const handleNewNotif = useCallback((newNotif) => {
    // Console-ը թողնում ենք անգլերեն, որ ավելի պրոֆեսիոնալ լինի
    console.log("📩 Socket data received:", newNotif);

    const isRevision = newNotif.type === 'PRICE_REVISION' || newNotif.newOrderId;
    const isFinish = newNotif.type === 'ORDER_FINISHED_APPROVE' || newNotif.type === 'open_finish_modal';
    
    if (isRevision || isFinish) {
        setOrderActionModal({ 
            isOpen: true, 
            data: { 
                ...newNotif,
                type: isFinish ? 'ORDER_FINISHED_APPROVE' : newNotif.type 
            } 
        });
        audio.play().catch(() => {});
    } else {
        const isActuallyOrder = !!(newNotif.service_name || newNotif.orderId || newNotif.type === 'order');
        const formatted = {
            id: newNotif.id || newNotif.orderId || Date.now(),
            type: isActuallyOrder ? 'order' : 'admin', 
            // ✨ ՓՈԽՎԱԾ ՏՈՂ: 'Պատվեր'-ը դարձավ t('order_generic')
            service_name: newNotif.service_name || (isActuallyOrder ? t('order_generic') : null),
            status: newNotif.status || 'new',
            message: newNotif.message || newNotif.title || '',
            is_read: 0,
            created_at: newNotif.created_at || new Date().toISOString()
        };

        setLastOrders(prev => [formatted, ...prev].slice(0, 10));
        setUnreadCount(prev => prev + 1);
        audio.play().catch(() => {});
        
        // ✨ ՓՈԽՎԱԾ ՏՈՂ: "Նոր ծանուցում"-ը դարձավ t('new_notification')
        toast.success(formatted.message || t('new_notification'));
    }
}, [audio, t]); // 🔥 ՇԱՏ ԿԱՐԵՎՈՐ Է: Ավելացրինք 't'-ն այստեղ


useEffect(() => {
    if (!user?.id) return;

    // 1. Սահմանում ենք Room մտնելու ֆունկցիան
    const joinRoom = () => {
        socket.emit('join', `user_${user.id}`);
        console.log(`🏠 Սոկետը միացավ սենյակին: user_${user.id}`);
    };

    // Անմիջապես փորձում ենք մտնել սենյակ
    joinRoom();

    // Եթե սոկետը վերամիանա (reconnect), նորից ենք մտնում սենյակ
    socket.on('connect', joinRoom);

    // 2. Լսում ենք սովորական ծանուցումները
    socket.on('notification', (data) => {
        console.log("📩 Նոր ծանուցում:", data);
        handleNewNotif(data);
    });

    // 3. 🔥 ՀԵՆՑ ԱՅՍ ՄԱՍՆ ԷՐ ՊԱԿԱՍՈՒՄ՝ Ադմինի "Ավարտել"-ի լսողը
    socket.on('open_finish_modal', (data) => {
        console.log("🏁 ԱԴՄԻՆԻՑ ԵԿԱՎ ԱՎԱՐՏԻ ՀՐԱՀԱՆԳ:", data);
        
        // Ձեռքով բացում ենք մոդալը
        setOrderActionModal({
            isOpen: true,
            data: { 
                ...data, 
                type: 'ORDER_FINISHED_APPROVE' // Սա կբացի վճարման/աստղիկների ստեփը
            }
        });
        
        // Նաև ձայնը միացնենք
        if (audio) audio.play().catch(e => console.log("Audio play error:", e));
    });

    socket.on(`notification_customer_${user.phone}`, (data) => {
        console.log("📩 Ծանուցում ըստ հեռախոսի:", data);
        handleNewNotif(data);
    });

    // Մաքրում ենք բոլոր լիսեներները
    return () => {
        socket.off('connect', joinRoom);
        socket.off('notification');
        socket.off('open_finish_modal');
        socket.off(`notification_customer_${user.phone}`);
    };
}, [user?.id, user?.phone, handleNewNotif, audio]);





useEffect(() => {
    if (!socket || !user?.id) return;

    socket.on('order_status_changed', (data) => {
        const { orderId, status, service_name } = data;

        const style = STATUS_STYLES[status] || STATUS_STYLES.new;
        const newNotif = {
            id: orderId || Date.now(),
            type: 'order',
            // ✨ ՓՈԽՎԱԾ: 'Պատվեր' -> t('order_generic')
            service_name: service_name || t('order_generic'), 
            status: status,
            // ✨ ՓՈԽՎԱԾ: Տեքստը սարքում ենք թարգմանվող
            message: `${t('status_changed_to')}: ${style.label}`,
            is_read: 0,
            created_at: new Date().toISOString()
        };

        setLastOrders(prev => [newNotif, ...prev].slice(0, 10));
        setUnreadCount(prev => prev + 1);
        audio.play().catch(() => {});

        // ✨ ՓՈԽՎԱԾ: Toast-ի տեքստը
        toast.success(`${t('order_generic')} #${orderId}: ${style.label}`, {
            icon: style.icon,
            duration: 5000
        });
    });

    return () => socket.off('order_status_changed');
    // 🔥 ԿԱՐԵՎՈՐ: Dependency-ի մեջ ավելացրու [t], որ լեզուն փոխելիս սոկետի տեքստն էլ թարմանա
}, [socket, user?.id, audio, setLastOrders, setUnreadCount, t, STATUS_STYLES]);
    return (
        <div style={{ position: 'relative', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
           <SEOManager categories={categories} />
            <Toaster position="top-center" />
            
            {/* ՄԻԱՍՆԱԿԱՆ ՆՈՐ ՄՈԴԱԼԸ */}
            <OrderActionModal 
                isOpen={orderActionModal.isOpen} 
                data={orderActionModal.data} 
                onAction={handleOrderAction}
            />

            {!isAdminPath && (
                <CallModal 
                    isOpen={showCallModal} 
                    onClose={() => setShowCallModal(false)} 
                    phone={settings.phone} 
                />
            )}

            <Navbar 
                user={user} 
                isAdminPath={isAdminPath} 
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen} 
                closeAll={closeAll} 
                subservices={subservices}
                categories={categories} 
                showCallModal={showCallModal} 
                setShowCallModal={setShowCallModal}
                unreadCount={unreadCount} 
                isNotifOpen={isNotifOpen} 
                setIsNotifOpen={() => setIsNotifOpen(!isNotifOpen)}
                lastOrders={lastOrders} 
                statusTranslations={statusTranslations}
                navigate={navigate} 
                markAsRead={markAsRead}
                openCat={openCat} 
    setOpenCat={setOpenCat}
            />
<main 
  className="main-content" 
  style={{ 
    flex: 1, 
    // Ավելացնում ենք բավարար տեղ վերևից
    paddingTop: isAdminPath ? 0 : (isMobile ? '120px' : '0px'), 
    paddingBottom: (isAdminPath || !isMobile) ? 0 : '80px',
    minHeight: '100vh'
  }}
>  <Routes>
        {/* 1. Գլխավոր էջ */}
        <Route path="/" element={<Home settings={settings} partners={partners} />} />

        {/* 2. Հիմնական տեղեկատվական էջեր */}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact settings={settings} />} />
        <Route path="/portfolio" element={<Projects />} />
        <Route path="/partners" element={<Partners partners={partners} />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        {/* 3. Օգտատիրոջ հաշիվ և Ծանուցումներ */}
        <Route path="/user-login" element={<UserLogin setUser={setUser} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/notifications" element={<Notifications user={user} refreshUnreadCount={() => setUnreadCount(0)} />} />
        <Route 
            path="/profile" 
            element={<Profile user={user} setUser={setUser} onLogout={() => { localStorage.clear(); setUser(null); navigate('/'); }} />} 
        />
        <Route path="/my-orders" element={<MyOrders user={user} />} />
          
        {/* 4. Ծառայություններ և Հաշվիչներ */}
        <Route path="/service/:id" element={<ServiceDetail />} />
        <Route path="/subservice/:id" element={<SubServicePage />} />
    <Route path="/calculators/:slug" element={<CalculatorsHub />} />
  
  {/* 2. Հաշվիչների էջը (առանց սլագի՝ ցուցակը) */}
  <Route path="/calculators" element={<CalculatorsHub />} />

        {/* 5. Ադմինիստրացիա */}
        <Route path="/admin/*" element={<Admin />} />

        {/* 6. Եթե հասցեն սխալ է գրված, հետ ուղարկել գլխավոր էջ */}
        <Route path="*" element={<Navigate to="/" />} />
    </Routes>
</main>
{/* ✨ CHATBOT-Ը ԴՆՈՒՄ ԵՆՔ ԱՅՍՏԵՂ (Main-ից դուրս) ✨ */}
        {!isAdminPath && <ChatBot user={user} />}

            {!isAdminPath && isMobile && (
                <MobileBottomNav 
                    user={user} 
                    location={location} 
                    closeAll={closeAll}
                    setShowCallModal={setShowCallModal} 
                    mobileNavStyle={mobileNavStyle}
                    navItemStyle={navItemStyle} 
                    callButtonStyle={callButtonStyle}
                />
            )}
            {!isAdminPath && <Footer settings={settings} />}
        </div>
    );
}

function App() {
    return (
        <HelmetProvider>
            <Router>
                <AppContent />
            </Router>
        </HelmetProvider>
    );
}

export default App;